module.exports = __webpack_public_path__ + "img/settlement.0b567b6d.png";